"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_styles_1 = require("./Card.styles");
var formatAndDropDecimal_1 = __importDefault(require("../../../utils/formatAndDropDecimal"));
var TradeInSection = function (_a) {
    var tradeInCredit = _a.tradeInCredit, card = _a.card;
    var positiveEquity = tradeInCredit > 0;
    var textToUse = {
        once: {
            positive: 'Your trade-in value is applied to your purchase, reducing your total purchase price.',
            negative: 'Carvana will facilitate paying off the balance on your trade-in. Your total purchase price reflect the application of your trade-in to your purchase.'
        },
        monthly: {
            positive: 'Your trade-in value is applied to your purchase, reducing your cash down payment and lowering your monthly payment.',
            negative: 'Carvana will facilitate paying off the balance on your trade-in. Your cash down payment and total amount financed reflect the application of your trade-in to your purchase.'
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_styles_1.LineItem, null,
            react_1.default.createElement("span", null, positiveEquity ? 'Trade-in value' : 'Trade-in balance due'),
            react_1.default.createElement("span", null,
                positiveEquity ? '- ' : '',
                "$",
                (0, formatAndDropDecimal_1.default)(Math.abs(tradeInCredit)))),
        react_1.default.createElement(Card_styles_1.DisclaimerText, null, positiveEquity ? textToUse[card].positive : textToUse[card].negative)));
};
exports.default = TradeInSection;
//# sourceMappingURL=TradeInSection.js.map